(function componentForm($, Adzuki)
{
	'use strict';

	var form = {
		name: 'ConsumerInsurancePurchase',
	};

	var label_name         = 'consumerinsurancepurchase';
	var choose_cc_type     = null;

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		choose_cc_type = $('#' + label_name + '-credit_card_type_id');

		// when choosing a credit card type
		choose_cc_type.change(changeCreditCardType);
	};

	function changeCreditCardType(event)
	{
		var credit_card_type = parseInt($(this).val());

		if (credit_card_type === 1) {
			$('.amex-card-type').removeClass('hidden');
		} else {
			$('.amex-card-type').addClass('hidden');
			$('#' + label_name + '-credit_card_type_branch_id').val('');
		}
	}
}(jQuery, window.Adzuki || {}));
